import { getLinesCount } from "./statistics";

const pricing = [
  [ 70, 60, 45, 35, 30 ],
  [ 80, 70, 55, 45, 40 ],
  [ 80, 70, 55, 45, 40 ],
  [ 90, 80, 65, 55, 50 ],
  [ 80, 70, 55, 45, 40 ]
];

const taxPhrase = 'Plus taxes & fees.';

const allPlansInclude = [
  {
    id: 1,
    title: 'Unlimited talk & text',
    description: 'Stay in touch and never worry about overage charges with unlimited Talk, Text and Data on the network more people rely on.'
  },
  {
    id: 2,
    title: '4G LTE',
    description: 'Our 4G LTE network provides the high speeds and reliability you\'ve come to expect. In times of congestion, your data may be temporarily slower than other traffic.'
  },
  {
    id: 3,
    title: 'Verizon Up rewards',
    description: 'With Verizon Up, you simply get more. More rewards. More access. More choices. Every month and then some. All to just say thanks for being with us.'
  },
  {
    id: 4,
    title: 'Mexico & Canada talk, text, & data',
    description: 'Talk, text and use unlimited data when traveling in Mexico and Canada. Data speeds are reduced to 2G after 0.5 GB/day. Also includes Unlimited talk and text to Mexico and Canada when you are in the US.'
  },
  {
    id: 5,
    title: 'International texting',
    description: 'Unlimited texting from the US to over 200 countries and territories worldwide.'
  },
  {
    id: 6,
    title: 'Call Filter spam blocker',
    description: 'With Verizon Call Filter from Verizon, screen incoming calls and filter spam. Fine-tune your settings to automatically block high-risk calls by risk level. Upgrade to Call Filter Plus for $2.99/mo for one line or $7.99/mo for 3+ lines.'
  }
];

const SavingsUp50Percent5GLTE = {
  title: 'Up to 50% off Verizon 5G Home or LTE Home&nbsp;Internet',
  description: 'Get up to 50% off your Verizon 5G Home or LTE Home Internet plan where service is available (as low as $25/mo with AutoPay).'
};

const Empty = {
  title: '—',
  specialClass: '-empty'
};

const Nationwide5GStart = {
  title: '5G Nationwide',
  description: 'Get unlimited access to our 5G Nationwide network. When combined with 5G Ultra Wideband, you’ll get our fastest performance. Requires a 5G-capable device inside the 5G Nationwide coverage area. When network is experiencing heavy traffic, your data may be temporarily slowed.'
};

const Nationwide5G = {
  title: '5G Nationwide',
  description: 'Get unlimited access to our 5G Nationwide network. When combined with 5G Ultra Wideband, you’ll get our best performance.<br/><br/>5G Nationwide available in 2,700+ cities. Requires a 5G-capable device inside the 5G Nationwide coverage area.'
};

const UnlimitedData = {
  title: 'Unlimited data',
  description: 'Get unlimited data from the world\'s most reliable network.  When the network is experiencing heavy traffic, your data may be temporarily slowed.'
};

const UltraWideband5G = {
  title: '5G Ultra Wideband',
  description: '5G Ultra Wideband is the fastest 5G network access we offer. Download apps, games, entire playlists and TV series in seconds. You\'ll also get 5G Ultra Wideband mobile hotspot and crystal-clear 4K Ultra High Definition video streaming when activated on a capable device. Plus access experiences from our exclusive 5G partners: Snapchat, Live Nation, Riot Games, and Niantic, launching throughout 2022. For full details, visit the <u>5G experience page</u> <span class="verizon-description-link">(https://www.verizon.com/5g/)</span>.<br/><br/>5G Ultra Wideband available only in parts of select cities and access requires a 5G Ultra Wideband-capable device inside the 5G Ultra Wideband coverage area. Depending on location, uploading is performed over 5G Ultra Wideband or 4G LTE.'
};

const PremiumNetworkAccess50 = {
  title: '<b>50 GB</b> premium network access, then&nbsp;unlimited data',
  description: 'Get 50 GB of 5G Nationwide / 4G LTE premium data per month. You’ll also get high-definition 720p video streaming on 5G Nationwide / 4G LTE when you activate it in your plan settings.<br/><br/>In times of congestion, your smartphone and mobile hotspot data may be temporarily slower than other traffic after exceeding 50 GB/mo/line of 5G Nationwide / 4G LTE data.'
};

const UnlimitedPremiumNetworkAccess = {
  title: '<b>Unlimited</b> premium network access',
  description: 'Get unlimited high-speed data that isn\'t slowed based on how much data you use. You\'ll also get high-definition 720p video streaming on 5G Nationwide / 4G LTE when you activate it in your plan settings.',
  specialClass: '-unlimited-premium-access-min-height'
};

const MobileHotspotData25 = {
  title: '<b>25 GB</b> premium mobile hotspot data, then unlimited lower-speed data',
  description: 'Get high-speed 5G/4G hotspot data that your other devices can use. Your smartphone becomes a Wi-Fi connection for devices like tablets, laptops, and more.<br/><br/>During times of congestion, 5G Nationwide / 4G LTE hotspot data may be temporarily slower than other traffic after 25 GB/mo of 5G Nationwide / 4G LTE smartphone data. After exceeding 25 GB/mo of 5G Ultra Wideband, 5G Nationwide, or 4G LTE data, you can still use hotspot at lower speeds of 3 Mbps when on 5G Ultra Wideband and 600 Kbps when on 5G Nationwide / 4G LTE for the rest of the month. 5G access requires a 5G-capable device.'
};

const MobileHotspotData50 = {
  title: '<b>50 GB</b> premium mobile hotspot data, then unlimited lower-speed data',
  description: 'Get high-speed 5G/4G hotspot data that your other devices can use. Your smartphone becomes a Wi-Fi connection for devices like tablets, laptops, and more.<br/><br/>During times of congestion, 5G Nationwide / 4G LTE hotspot data may be temporarily slower than other traffic after 50 GB/mo of 5G Nationwide / 4G LTE smartphone data. After exceeding 50 GB/mo of 5G Ultra Wideband, 5G Nationwide, or 4G LTE data, you can still use hotspot at lower speeds of 3 Mbps when on 5G Ultra Wideband and 600 Kbps when on 5G Nationwide / 4G LTE for the rest of the month. 5G access requires a 5G-capable device.'
};

const CloudStorage600 = {
  iconName: 'cloud',
  title: 'Verizon Cloud 600 GB',
  description: 'Wirelessly back up and sync your contacts, photos, videos, messages & documents to the Verizon Cloud. 600 GB included with this plan, or upgrade to 2 TB for an additional $9/mo or Unlimited for an additional $14/mo.'
};

const huluDisneyESPN = {
  title: 'Hulu, Disney+, ESPN+',
  hideTitle: true,
  iconName: 'disney-bundle',
  description: 'Get the best in movies, shows, and sports with Disney+, Hulu, and ESPN+ included. There’s something for everyone with epic stories, tons of TV, and live sports. One subscription can be shared with everyone on your account. A $13.99/mo value, included on us for as long as you stay on an eligible plan.'
};

const AppleArcadeOrGooglePlay = {
  title: 'Apple Arcade or Google Play Pass',
  hideTitle: true,
  iconName: 'arcade-gpp',
  description: 'Enjoy unlimited access to 180+ incredibly fun games across all your Apple devices, with no ads and no in-app purchases. A $4.99/mo value, included on us for as long as you stay on an eligible plan.<br/><br/>Google Play Pass is your ticket to hundreds of awesome games and apps, completely free of ads and in-app purchases. Explore a curated collection with favorites like Stardew Valley and the Monument Valley series to award-winning indies like LIMBO and Dead Cells. A $4.99/mo value.'
};

const AppleMusic6 = {
  title: 'Also try Apple Music for 6 mos. on us',
  description: 'With Apple Music, you can play 75 million songs ad-free, online or off. Immerse yourself in spatial audio with Dolby Atmos. And unlock amazing definition with lossless audio, at no extra cost. A $9.99/mo value, included on us for 6 months. Cancel anytime.'
};

const AppleMusic = {
  title: 'Apple Music',
  iconName: 'music',
  hideTitle: true,
  description: 'With Apple Music, you can play 75 million songs ad-free, online or off. Immerse yourself in spatial audio with Dolby Atmos. And unlock amazing definition with lossless audio, at no extra cost. A $9.99/mo value.'
};

const TravelPass = {
  iconName: 'travel-pass',
  title: '1 TravelPass day per month',
  description: 'Get 1 TravelPass® day each month, accumulating up to 12 days each year. TravelPass days give you unlimited talk, text and data in more than 185 countries for 24 hours, included each month on us for as long as you stay on this plan. TravelPass® days expire 12 months after issue date.'
};

const UpTo50off = {
  iconName: 'wearable',
  title: 'Up to 50% off a watch, tablet, hotspot, or Hum plan',
  description: 'Get up to 50% off one eligible plan for a qualifying smartwatch, tablet, hotspot, or Hum in-car Wi-Fi device.<br/><br/>Eligible plans and discounts: 50% off Unlimited and Unlimited Plus for tablets; Essential and Plus plans for mobile hotspot devices; Unlimited for HumX; Unlimited + In Car WiFi for Hum+; and Unlimited and Number Share Unlimited for smartwatches. $20 off Premium and Pro plans for mobile hotspot devices.'
};

const TryPerks6 = {
  title: 'Also try Disney+, Apple Arcade or Google Play Pass, and Apple Music for 6 mos. on us',
  description: '<b>Disney+</b><br/>All the best stories from Disney, Pixar, Marvel, Star Wars, and National Geographic. First 6 months on us, then $7.99/mo plus tax after offer ends. One subscription can be shared with everyone on your account. Cancel anytime.<br/><br/><b>Apple Music</b><br/>With Apple Music, you can play 75 million songs ad-free, online or off. Immerse yourself in spatial audio with Dolby Atmos. And unlock amazing definition with lossless audio. A $9.99/mo value.<br/><br/><b>Apple Arcade or Google Play Pass</b><br/>Enjoy unlimited access to 180+ incredibly fun games across all your Apple devices, with no ads and no in-app purchases. After offer ends, Apple bills $4.99/mo plus tax. Cancel anytime.<br/><br/>Google Play Pass is your ticket to hundreds of awesome games and apps, completely free of ads and in-app purchases. Explore a curated collection with favorites like Stardew Valley and the Monument Valley series to award-winning indies like LIMBO and Dead Cells. $4.99/mo plus tax after offer ends. Cancel anytime.'
};

const compareFeatures = {
  unlimitedTalkText: {
    description: 'Stay in touch and never worry about overage charges with unlimited Talk, Text and Data on the network more people rely on.'
  },
  ultraWideband5G: {
    description: '5G Ultra Wideband is the fastest 5G network access we offer. Download apps, games, entire playlists and TV series in seconds. You\'ll also get 5G Ultra Wideband mobile hotspot and crystal-clear 4K Ultra High Definition video streaming when activated on a capable device. Plus access experiences from our exclusive 5G partners: Snapchat, Live Nation, Riot Games, and Niantic, launching throughout 2022. For full details, visit the <u>5G experience page</u> <span class="verizon-description-link">(https://www.verizon.com/5g/)</span>.<br/><br/>5G Ultra Wideband available only in parts of select cities and access requires a 5G Ultra Wideband-capable device inside the 5G Ultra Wideband coverage area. Depending on location, uploading is performed over 5G Ultra Wideband or 4G LTE.'
  },
  nationWide5G: {
    description: 'Get unlimited access to our 5G Nationwide network. When combined with 5G Ultra Wideband, you’ll get our best performance.<br/><br/>5G Nationwide available in 2,700+ cities. Requires a 5G-capable device inside the 5G Nationwide coverage area.'
  },
  nationWide5GPlan1: {
    description: 'Get unlimited access to our 5G Nationwide network. When combined with 5G Ultra Wideband, you’ll get our fastest performance. Requires a 5G-capable device inside the 5G Nationwide coverage area. When network is experiencing heavy traffic, your data may be temporarily slowed.'
  },
  premiumNetworkAccess50GB: {
    note: '<b>50 GB</b> premium network access, then unlimited data',
    description: 'Get 50 GB of 5G Nationwide / 4G LTE premium data per month. You’ll also get high-definition 720p video streaming on 5G Nationwide / 4G LTE when you activate it in your plan settings.<br/><br/>In times of congestion, your smartphone and mobile hotspot data may be temporarily slower than other traffic after exceeding 50 GB/mo/line of 5G Nationwide / 4G LTE data.'
  },
  premiumNetworkAccessUnlim: {
    note: '<b>Unlimited</b> premium network access',
    description: 'Get unlimited high-speed data that isn\'t slowed based on how much data you use. You\'ll also get high-definition 720p video streaming on 5G Nationwide / 4G LTE when you activate it in your plan settings.'
  },
  LTE4G: {
    description: 'Our 4G LTE network provides the high speeds and reliability you\'ve come to expect. In times of congestion, your data may be temporarily slower than other traffic.'
  },
  mobileHotspot25GB: {
    note: '<b>25 GB</b> premium mobile hotspot data, then unlimited lower-speed data',
    description: 'Get high-speed 5G/4G hotspot data that your other devices can use. Your smartphone becomes a Wi-Fi connection for devices like tablets, laptops, and more.<br/><br/>During times of congestion, 5G Nationwide / 4G LTE hotspot data may be temporarily slower than other traffic after 25 GB/mo of 5G Nationwide / 4G LTE smartphone data. After exceeding 25 GB/mo of 5G Ultra Wideband, 5G Nationwide, or 4G LTE data, you can still use hotspot at lower speeds of 3 Mbps when on 5G Ultra Wideband and 600 Kbps when on 5G Nationwide / 4G LTE for the rest of the month. 5G access requires a 5G-capable device.'
  },
  mobileHotspot50GB: {
    note: '<b>50 GB</b> premium mobile hotspot data, then unlimited lower-speed data',
    description: 'Get high-speed 5G/4G hotspot data that your other devices can use. Your smartphone becomes a Wi-Fi connection for devices like tablets, laptops, and more.<br/><br/>During times of congestion, 5G Nationwide / 4G LTE hotspot data may be temporarily slower than other traffic after 50 GB/mo of 5G Nationwide / 4G LTE smartphone data. After exceeding 50 GB/mo of 5G Ultra Wideband, 5G Nationwide, or 4G LTE data, you can still use hotspot at lower speeds of 3 Mbps when on 5G Ultra Wideband and 600 Kbps when on 5G Nationwide / 4G LTE for the rest of the month. 5G access requires a 5G-capable device.'
  },

  savingsUpTo50Percents: {
    description: 'Get up to 50% off your Verizon 5G Home or LTE Home Internet plan where service is available (as low as $25/mo with AutoPay).'
  },

  disney6Month: {
    note: '6 months on us',
    description: 'All the best stories from Disney, Pixar, Marvel, Star Wars, and National Geographic. First 6 months on us, then $7.99/mo plus tax after offer ends. One subscription can be shared with everyone on your account. Cancel anytime.'
  },
  disneyIncluded: {
    note: 'Included',
    description: 'Get the best in movies, shows, and sports with Disney+, Hulu, and ESPN+ included. There’s something for everyone with epic stories, tons of TV, and live sports. One subscription can be shared with everyone on your account. A $13.99/mo value, included on us for as long as you stay on an eligible plan.'
  },
  huluIncluded: {
    note: 'Included',
    description: 'Get the best in movies, shows, and sports with Disney+, Hulu, and ESPN+ included. There’s something for everyone with epic stories, tons of TV, and live sports. One subscription can be shared with everyone on your account. A $13.99/mo value, included on us for as long as you stay on an eligible plan.'
  },
  ESPNIncluded: {
    note: 'Included',
    description: 'Get the best in movies, shows, and sports with Disney+, Hulu, and ESPN+ included. There’s something for everyone with epic stories, tons of TV, and live sports. One subscription can be shared with everyone on your account. A $13.99/mo value, included on us for as long as you stay on an eligible plan.'
  },
  appleArcadeOrGooglePlayPass6Month: {
    note: '6 months on us',
    description: 'Enjoy unlimited access to 180+ incredibly fun games across all your Apple devices, with no ads and no in-app purchases. ' +
      'After offer ends, Apple bills $4.99/mo plus tax. Cancel anytime.<br/><br/>' +
      'Google Play Pass is your ticket to hundreds of awesome games and apps, completely free of ads and in-app purchases. ' +
      'Explore a curated collection with favorites like Stardew Valley and the Monument Valley series to award-winning indies like LIMBO and Dead Cells. ' +
      '$4.99/mo plus tax after offer ends. Cancel anytime.'
  },
  appleArcadeOrGooglePlayPassIncluded: {
    note: 'Included',
    description: 'Enjoy unlimited access to 180+ incredibly fun games across all your Apple devices, with no ads and no in-app purchases. ' +
      'A $4.99/mo value, included on us for as long as you stay on an eligible plan.<br/><br/>' +
      'Google Play Pass is your ticket to hundreds of awesome games and apps, completely free of ads and in-app purchases. ' +
      'Explore a curated collection with favorites like Stardew Valley and the Monument Valley series to award-winning indies like LIMBO and Dead Cells. A $4.99/mo value.'
  },
  appleMusic6Month: {
    note: '6 months on us',
    description: 'With Apple Music, you can play 75 million songs ad-free, online or off. Immerse yourself in spatial audio with Dolby Atmos. And unlock amazing definition with lossless audio, at no extra cost. A $9.99/mo value, included on us for 6 months. Cancel anytime.'
  },
  appleMusicIncluded: {
    note: 'Included',
    description: 'With Apple Music, you can play 75 million songs ad-free, online or off. Immerse yourself in spatial audio with Dolby Atmos. And unlock amazing definition with lossless audio, at no extra cost. A $9.99/mo value.'
  },
  upTo50PercentsWatchTablet: {
    description: 'Get up to 50% off one eligible plan for a qualifying smartwatch, tablet, hotspot, or Hum in-car Wi-Fi device.<br/><br/>Eligible plans and discounts: 50% off Unlimited and Unlimited Plus for tablets; Essential and Plus plans for mobile hotspot devices; Unlimited for HumX; Unlimited + In Car WiFi for Hum+; and Unlimited and Number Share Unlimited for smartwatches. $20 off Premium and Pro plans for mobile hotspot devices.'
  },
  travelPass: {
    description: 'Get 1 TravelPass® day each month, accumulating up to 12 days each year. TravelPass days give you unlimited talk, text and data in more than 185 countries for 24 hours, included each month on us for as long as you stay on this plan. TravelPass® days expire 12 months after issue date.\n'
  },
  verizonCloud: {
    note: '600GB',
    description: 'Wirelessly back up and sync your contacts, photos, videos, messages & documents to the Verizon Cloud. 600 GB included with this plan, or upgrade to 2 TB for an additional $9/mo or Unlimited for an additional $14/mo.'
  },
  verizonUpRewards: {
    description: 'With Verizon Up, you simply get more. More rewards. More access. More choices. Every month and then some. All to just say thanks for being with us.'
  },
  MexicoCanada: {
    description: 'Talk, text and use unlimited data when traveling in Mexico and Canada. Data speeds are reduced to 2G after 0.5 GB/day. Also includes Unlimited talk and text to Mexico and Canada when you are in the US.'
  },
  internationalTexting: {
    description: 'Unlimited texting from the US to over 200 countries and territories worldwide.'
  },
  callFilterSmapBlocker: {
    description: 'With Verizon Call Filter from Verizon, screen incoming calls and filter spam. Fine-tune your settings to automatically block high-risk calls by risk level. Upgrade to Call Filter Plus for $2.99/mo for one line or $7.99/mo for 3+ lines.'
  }
};

const compareAllPlanInclude = {
  unlimitedTalkText: {
    value: true,
    about: compareFeatures.unlimitedTalkText
  },
  LTE4G: {
    value: true,
    about: compareFeatures.LTE4G
  },
  verizonUpRewards: {
    value: true,
    about: compareFeatures.verizonUpRewards
  },
  MexicoCanada: {
    value: true,
    about: compareFeatures.MexicoCanada
  },
  internationalTexting: {
    value: true,
    about: compareFeatures.internationalTexting
  },
  callFilterSmapBlocker: {
    value: true,
    about: compareFeatures.callFilterSmapBlocker
  }
};


const startUnlimited = {
  id: 1,
  name: "5G Start",
  description: "Just the basics.",
  featuresTitle: "5G access",
  features: [
    Empty,
    Nationwide5GStart,
    UnlimitedData
  ],
  perksTitle: 'Perks to try, on us',
  perks: [
    TryPerks6
  ],
  compare: {
    totalAccess: {
      ultraWideband5G: {
        value: false
      },
      nationWide5G: {
        value: true,
        about: compareFeatures.nationWide5GPlan1
      },
      premiumNetworkAccess: {
        value: false
      },
      mobileHotspot: {
        value: false
      }
    },
    savings: {
      upTo50Percents: {
        value: false
      }
    },
    planPerks: {
      subtitle: false,
      disney: {
        value: true,
        about: compareFeatures.disney6Month
      },
      hulu: {
        value: false
      },
      espn: {
        value: false
      },
      appleArcadeOrGooglePlayPass: {
        value: true,
        about: compareFeatures.appleArcadeOrGooglePlayPass6Month
      },
      appleMusic: {
        value: true,
        about: compareFeatures.appleMusic6Month
      },
      upTo50PercentsWatchTablet: {
        value: false
      },
      travelPass: {
        value: false
      },
      verizonCloud: {
        value: false
      }
    },
    allPlansInclude: compareAllPlanInclude
  },
  taxPhrase
};

const playMoreUnlimited = {
  id: 2,
  name: "5G Play More",
  description: "For all your entertainment needs.",
  featuresTitle: "5G total access",
  features: [
    UltraWideband5G,
    Nationwide5G,
    PremiumNetworkAccess50,
    MobileHotspotData25
  ],
  savingsTitle: 'Home internet savings',
  savings: [ SavingsUp50Percent5GLTE ],
  perksTitle: 'Entertainment on us',
  perksNote: 'An $18.98 value included',
  perks: [
    huluDisneyESPN,
    AppleArcadeOrGooglePlay
  ],
  other: [
    AppleMusic6
  ],
  rateLabel: 'Popular',
  compare: {
    totalAccess: {
      ultraWideband5G: {
        value: true,
        about: compareFeatures.ultraWideband5G
      },
      nationWide5G: {
        value: true,
        about: compareFeatures.nationWide5G
      },
      premiumNetworkAccess: {
        value: true,
        about: compareFeatures.premiumNetworkAccess50GB
      },
      mobileHotspot: {
        value: true,
        about: compareFeatures.mobileHotspot25GB
      }
    },
    savings: {
      upTo50Percents: {
        value: true,
        about: compareFeatures.savingsUpTo50Percents
      }
    },
    planPerks: {
      subtitle: {
        title: "Entertainment on us",
        description: "An $18.98 value included"
      },
      disney: {
        value: true,
        about: compareFeatures.disneyIncluded
      },
      hulu: {
        value: true,
        about: compareFeatures.huluIncluded
      },
      espn: {
        value: true,
        about: compareFeatures.ESPNIncluded
      },
      appleArcadeOrGooglePlayPass: {
        value: true,
        about: compareFeatures.appleArcadeOrGooglePlayPassIncluded
      },
      appleMusic: {
        value: true,
        about: compareFeatures.appleMusic6Month
      },
      upTo50PercentsWatchTablet: {
        value: false
      },
      travelPass: {
        value: false
      },
      verizonCloud: {
        value: false
      }
    },
    allPlansInclude: compareAllPlanInclude
  },
  taxPhrase
};

const doMoreUnlimited = {
  id: 3,
  name: "5G Do More",
  description: "Staying mobile, even around the world.",
  featuresTitle: "5G total access",
  features: [
    UltraWideband5G,
    Nationwide5G,
    PremiumNetworkAccess50,
    MobileHotspotData25
  ],
  savingsTitle: 'Home internet savings',
  savings: [ SavingsUp50Percent5GLTE ],
  perksTitle: 'Connectivity on us',
  perksNote: 'Up to a $35.99 value included',
  perks: [
    UpTo50off,
    TravelPass,
    CloudStorage600
  ],
  other: [
    TryPerks6
  ],
  compare: {
    totalAccess: {
      ultraWideband5G: {
        value: true,
        about: compareFeatures.ultraWideband5G
      },
      nationWide5G: {
        value: true,
        about: compareFeatures.nationWide5G
      },
      premiumNetworkAccess: {
        value: true,
        about: compareFeatures.premiumNetworkAccess50GB
      },
      mobileHotspot: {
        value: true,
        about: compareFeatures.mobileHotspot25GB
      }
    },
    savings: {
      upTo50Percents: {
        value: true,
        about: compareFeatures.savingsUpTo50Percents
      }
    },
    planPerks: {
      subtitle: {
        title: "Connectivity on us",
        description: "Up to a $35.99 value included"
      },
      disney: {
        value: true,
        about: compareFeatures.disney6Month
      },
      hulu: {
        value: false
      },
      espn: {
        value: false
      },
      appleArcadeOrGooglePlayPass: {
        value: true,
        about: compareFeatures.appleArcadeOrGooglePlayPass6Month
      },
      appleMusic: {
        value: true,
        about: compareFeatures.appleMusic6Month
      },
      upTo50PercentsWatchTablet: {
        value: true,
        about: compareFeatures.upTo50PercentsWatchTablet
      },
      travelPass: {
        value: true,
        about: compareFeatures.travelPass
      },
      verizonCloud: {
        value: true,
        about: compareFeatures.verizonCloud
      }
    },
    allPlansInclude: compareAllPlanInclude
  },
  taxPhrase
};

const getMoreUnlimited = {
  id: 4,
  name: "5G Get More",
  description: "Fully loaded, plus music.",
  featuresTitle: "5G total access",
  features: [
    UltraWideband5G,
    Nationwide5G,
    UnlimitedPremiumNetworkAccess,
    MobileHotspotData50
  ],
  savingsTitle: 'Home internet savings',
  savings: [ SavingsUp50Percent5GLTE ],
  perksTitle: 'Everything on us',
  perksNote: 'Up to a $64.96 value included',
  perks: [
    huluDisneyESPN,
    AppleArcadeOrGooglePlay,
    AppleMusic,
    UpTo50off,
    TravelPass,
    CloudStorage600
  ],
  compare: {
    totalAccess: {
      ultraWideband5G: {
        value: true,
        about: compareFeatures.ultraWideband5G
      },
      nationWide5G: {
        value: true,
        about: compareFeatures.nationWide5G
      },
      premiumNetworkAccess: {
        value: true,
        about: compareFeatures.premiumNetworkAccessUnlim
      },
      mobileHotspot: {
        value: true,
        about: compareFeatures.mobileHotspot50GB
      }
    },
    savings: {
      upTo50Percents: {
        value: true,
        about: compareFeatures.savingsUpTo50Percents
      }
    },
    planPerks: {
      subtitle: {
        title: "Everything on us",
        description: "Up to a $64.96 value included"
      },
      disney: {
        value: true,
        about: compareFeatures.disneyIncluded
      },
      hulu: {
        value: true,
        about: compareFeatures.huluIncluded
      },
      espn: {
        value: true,
        about: compareFeatures.ESPNIncluded
      },
      appleArcadeOrGooglePlayPass: {
        value: true,
        about: compareFeatures.appleArcadeOrGooglePlayPassIncluded
      },
      appleMusic: {
        value: true,
        about: compareFeatures.appleMusicIncluded
      },
      upTo50PercentsWatchTablet: {
        value: true,
        about: compareFeatures.upTo50PercentsWatchTablet
      },
      travelPass: {
        value: true,
        about: compareFeatures.travelPass
      },
      verizonCloud: {
        value: true,
        about: compareFeatures.verizonCloud
      }
    },
    allPlansInclude: compareAllPlanInclude
  },
  taxPhrase
};

const perkPacks = [
  {
    id: 'play_more',
    name: '5G Play More',
    description: 'Entertainment',
    defaultSelected: true,
    perksTitle: 'Entertainment on us',
    perksNote: 'An $18.98 value included',
    perks: [
      huluDisneyESPN,
      AppleArcadeOrGooglePlay,
      AppleMusic6
    ],
    compare: {
      planPerks: {
        subtitle: {
          title: "Entertainment on us",
          description: "An $18.98 value included"
        },
        disney: {
          value: true,
          about: compareFeatures.disneyIncluded
        },
        hulu: {
          value: true,
          about: compareFeatures.huluIncluded
        },
        espn: {
          value: true,
          about: compareFeatures.ESPNIncluded
        },
        appleArcadeOrGooglePlayPass: {
          value: true,
          about: compareFeatures.appleArcadeOrGooglePlayPassIncluded
        },
        appleMusic: {
          value: true,
          about: compareFeatures.appleMusic6Month
        },
        upTo50PercentsWatchTablet: {
          value: false
        },
        travelPass: {
          value: false
        },
        verizonCloud: {
          value: false
        }
      }
    }
  },
  {
    id: 'do_more',
    name: '5G Do More',
    description: 'Connectivity',
    perksTitle: 'Connectivity on us',
    perksNote: 'Up to a $35.99 value included',
    perks: [
      UpTo50off,
      TravelPass,
      CloudStorage600,
      TryPerks6
    ],
    compare: {
      planPerks: {
        subtitle: {
          title: "Connectivity on us",
          description: "Up to a $35.99 value included"
        },
        disney: {
          value: true,
          about: compareFeatures.disney6Month
        },
        hulu: {
          value: false
        },
        espn: {
          value: false
        },
        appleArcadeOrGooglePlayPass: {
          value: true,
          about: compareFeatures.appleArcadeOrGooglePlayPass6Month
        },
        appleMusic: {
          value: true,
          about: compareFeatures.appleMusic6Month
        },
        upTo50PercentsWatchTablet: {
          value: true,
          about: compareFeatures.upTo50PercentsWatchTablet
        },
        travelPass: {
          value: true,
          about: compareFeatures.travelPass
        },
        verizonCloud: {
          value: true,
          about: compareFeatures.verizonCloud
        }
      }
    }
  }
];

const chooseMoreUnlimited = {
  id: 5,
  name: "5G Choose More",
  description: "Choose entertainment or connectivity.",
  featuresTitle: "5G total access",
  features: [
    UltraWideband5G,
    Nationwide5G,
    PremiumNetworkAccess50,
    MobileHotspotData25
  ],
  savingsTitle: 'Home internet savings',
  savings: [ SavingsUp50Percent5GLTE ],
  perksTitle: null,
  perksNote: null,
  perks: [],
  other: [],
  rateLabel: 'Popular',
  compare: {
    totalAccess: {
      ultraWideband5G: {
        value: true,
        about: compareFeatures.ultraWideband5G
      },
      nationWide5G: {
        value: true,
        about: compareFeatures.nationWide5G
      },
      premiumNetworkAccess: {
        value: true,
        about: compareFeatures.premiumNetworkAccess50GB
      },
      mobileHotspot: {
        value: true,
        about: compareFeatures.mobileHotspot25GB
      }
    },
    savings: {
      upTo50Percents: {
        value: true,
        about: compareFeatures.savingsUpTo50Percents
      }
    },
    allPlansInclude: compareAllPlanInclude
  },
  choosePerkPack: perkPacks,
  taxPhrase
};

const bau_plans = [
  startUnlimited,
  playMoreUnlimited,
  doMoreUnlimited,
  getMoreUnlimited
].map((el) => ({
  ...el,
  get price() { return pricing[this.id - 1][getLinesCount() - 1]; }
}));

const flex_plans = [
  startUnlimited,
  chooseMoreUnlimited,
  {
    ...getMoreUnlimited,
    rateLabel: 'Best value',
    overTitle: 'All perks included',
    features: [
      UltraWideband5G,
      Nationwide5G,
      UnlimitedPremiumNetworkAccess,
      MobileHotspotData50
    ]
  }
].map((el) => ({
  ...el,
  get price() { return pricing[this.id - 1][getLinesCount() - 1]; }
}));

const compareList = [
  {
    id: "totalAccess",
    title: "5G total access",
    list: [
      {
        id: "ultraWideband5G",
        title: "5G Ultra Wideband",
        description: compareFeatures.ultraWideband5G.description
      },
      {
        id: "nationWide5G",
        title: "5G Nationwide",
        description: compareFeatures.nationWide5G.description
      },
      {
        id: "premiumNetworkAccess",
        title: "Premium network access",
        description: compareFeatures.premiumNetworkAccessUnlim.description
      },
      {
        id: "mobileHotspot",
        title: "Mobile hotspot data",
        description: compareFeatures.mobileHotspot50GB.description
      }
    ]
  },
  {
    id: "savings",
    title: "Home internet savings",
    list: [
      {
        id: "upTo50Percents",
        title: "Up to 50% off Verizon 5G Home or LTE Home Internet",
        description: compareFeatures.savingsUpTo50Percents.description
      }
    ]
  },
  {
    id: "planPerks",
    title: "Plan perks",
    subtitles: true,
    list: [
      {
        id: "disney",
        title: "Disney+",
        description: compareFeatures.disneyIncluded.description
      },
      {
        id: "hulu",
        title: "Hulu",
        description: compareFeatures.huluIncluded.description
      },
      {
        id: "espn",
        title: "ESPN+",
        description: compareFeatures.ESPNIncluded.description
      },
      {
        id: "appleArcadeOrGooglePlayPass",
        title: "Apple Arcade or Google Play Pass",
        description: compareFeatures.appleArcadeOrGooglePlayPassIncluded.description
      },
      {
        id: "appleMusic",
        title: "Apple Music",
        description: compareFeatures.appleMusicIncluded.description
      },
      {
        id: "upTo50PercentsWatchTablet",
        title: "Up to 50% off a watch, tablet, hotspot or Hum plan",
        description: compareFeatures.upTo50PercentsWatchTablet.description
      },
      {
        id: "travelPass",
        title: "1 TravelPass day per month",
        description: compareFeatures.travelPass.description
      },
      {
        id: "verizonCloud",
        title: "Verizon Cloud",
        description: compareFeatures.verizonCloud.description
      }
    ]
  },
  {
    id: "allPlansInclude",
    title: "All plans include",
    list: [
      {
        id: "unlimitedTalkText",
        title: "Unlimited talk & text",
        description: compareFeatures.unlimitedTalkText.description
      },
      {
        id: "LTE4G",
        title: "4G LTE",
        description: compareFeatures.LTE4G.description
      },
      {
        id: "verizonUpRewards",
        title: "Verizon Up rewards",
        description: compareFeatures.verizonUpRewards.description
      },
      {
        id: "MexicoCanada",
        title: "Mexico & Canada talk, text, & data",
        description: compareFeatures.MexicoCanada.description
      },
      {
        id: "internationalTexting",
        title: "International texting",
        description: compareFeatures.internationalTexting.description
      },
      {
        id: "callFilterSmapBlocker",
        title: "Call Filter spam blocker",
        description: compareFeatures.callFilterSmapBlocker.description
      }
    ]
  }
];

const BAU = { plans: bau_plans, allPlansInclude, pricing, compareList };
const FLEX = { plans: flex_plans, allPlansInclude, pricing, compareList };

export { BAU, FLEX, perkPacks };
